import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
import { compose } from "recompose";
import * as ROUTES from "../../constants/routes";
import { withFirebase } from "../../components/Firebase";
import LoadingIndicator from "../../components/LoadingIndicator";
import useEnterKeyListener from "../../helpers/useEnterKeyListener";
import Home from "../Home";
import { fbSetScreenName, fbSetEvent, fbSetParams } from "../../Action/firebaseAnalytics";
import { OPEN_SCREEN, ACCOUNT_VERIFIED_SCREEN } from "../../constants/firebaseAnalytics";
import "./index.css";
import { APP_NAME } from "../../constants/keys";

const EmailVerifiedModal = ({ firebase, history, oobCode }) => {
  const [showEmailVerified, setShowEmailVerfied] = useState(true);
  const [modalCloseStatus, setModalCloseStatus] = useState("close-left");
  const [loading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (oobCode) {
      firebase.emailVerified(oobCode);
    }
  }, [firebase, oobCode]);

  const handleResetModal = (status) => {
    setShowEmailVerfied(status);
  };

  const handleModalCloseState = (status) => {
    setModalCloseStatus(status);
  };

  const handleCloseverifiedModal = () => {
    handleModalCloseState("close-left");
    setShowEmailVerfied(false);
    history.push(ROUTES.HOME);
  };

  const handleVerifyBackDrop = () => {
    history.push(ROUTES.HOME);
    handleResetModal(false);
  };

  const handleFBEvents = (eventName, params) => {
    dispatch(fbSetParams(params));
    dispatch(fbSetEvent(eventName));
  };

  const handlefbSetScreen = () => {
    dispatch(fbSetScreenName(ACCOUNT_VERIFIED_SCREEN));
    handleFBEvents(OPEN_SCREEN, {});
  };

  useEffect(() => {
    if (showEmailVerified) {
      handlefbSetScreen();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showEmailVerified]);

  useEnterKeyListener({
    querySelectorToExecuteClick: "#EmailVerifiedBtn",
  });

  return (
    <>
      <Home />
      <Modal
        centered
        show={showEmailVerified}
        onHide={() => handleVerifyBackDrop()}
        className={`auth-modal login-modal ${showEmailVerified ? "right" : modalCloseStatus}`}
      >
        <Modal.Header>
          <div className="reset-password-back">
            <span
              onClick={() => {
                handleModalCloseState("close-right");
                handleResetModal(false);
              }}
            ></span>
          </div>
        </Modal.Header>
        <Modal.Body className="auth-modal-body">
          {loading && <LoadingIndicator loaderStyle="homePageLoader" />}
          <div>
            <div className="email-confirm-title email-verify-title">
              Welcome to {APP_NAME}! Your account is verified. Check out the opportunities we
              reserved for you!
            </div>

            <div className="login-btn">
              <button
                type="button"
                id="EmailVerifiedBtn"
                className="btn-pwa-signUp btn-verified-close"
                onClick={() => handleCloseverifiedModal()}
              >
                close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default compose(withRouter, withFirebase)(EmailVerifiedModal);
